/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, NavLink } from 'react-router-dom';
import moment from 'moment';
import { styled } from '@mui/material';
import toggle from '../../../../_assets/js/layout/base/aside.js';
import { fetchBookingList } from '../../../../../app/modules/ECommerce/_redux/booking/actions';
import { getBookingSetting } from '../../../../../app/modules/ECommerce/_redux/booking/crud';
import { fetchBookingBranchList } from '../../../../../app/modules/ECommerce/_redux/booking2/booking2Actions';
import { getAllWaittingBookingCount } from '../../../../../app/modules/ECommerce/pages/bookingV2/bookingBranch/getAllWaittingBookingCount';
import { usePendingOrders } from '../../../../../app/hooks/usePendingOrders.js';
import { useCustomTheme } from '../../../../../app/hooks/useCustomTheme.js';
import { useAppAliasIntlFormatter } from '../../../../../app/hooks/formatFeatureName.js';
import { useIntl } from 'react-intl';
import { useBooking2ShopSetting } from '../../../../../app/pages/home/hooks/useBooking2ShopSetting.js';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../../../../_helpers/AssetsHelpers.js';
import { customerMenuItems, menuItems } from './asideMenu2';
import { usePermissions } from '@/app/hooks/usePermissions';
import { shouldRenderSubMenuItem } from './asideUtils';
import SubMenuList from './SubMenuList';
import { USER_MODE } from '@/app/data/userModeConstants';

export function AsideMenuList2() {
  const { user, shop, customerMenuSetting } = useSelector(state => state.auth);

  const dispatch = useDispatch();
  const formatMessage = useAppAliasIntlFormatter();
  const intl = useIntl();
  const userMenu = useMemo(
    () => (user?.mode === USER_MODE.CUSTOMER ? customerMenuItems(user?.seqId) : menuItems(user?.seqId)),
    [user?.seqId, user?.mode]
  );

  const [bookingSetting, setBookingSetting] = useState(null);
  const location = useLocation();
  const { can, canAny } = usePermissions();
  const history = useHistory();

  const isEmptyHtml = html => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent.trim() === '';
  };

  const termValue = shop?.term?.terms?.[intl.locale];
  const isTerm = typeof termValue === 'string' && !isEmptyHtml(termValue);
  const isGlobalAdmin = user?.isGlobalAdmin;

  const isCustomer = user?.mode === USER_MODE.CUSTOMER;
  const bookingData = useSelector(state => state.booking.items);
  const { data: waitConfirmOrderAmount } = usePendingOrders();

  // const menuSettingMap = useMemo(() => {
  //   const map = new Map();
  //   (customerMenuSetting?.menu ?? []).forEach(m => map.set(m.name, m.active));
  //   return map;
  // }, [customerMenuSetting]);

  // const isEnabledBySetting = useCallback(
  //   item => {
  //     if (!isCustomer) return true;
  //     if (!item.settingKey) return true;
  //     if (!menuSettingMap.has(item.settingKey)) return true;
  //     return menuSettingMap.get(item.settingKey) === true;
  //   },
  //   [isCustomer, menuSettingMap]
  // );

  const initialMenuListToggleStatus =
    user && userMenu.reduce((acc, elem) => ({ ...acc, [elem.id]: false, 'menu.home': true }), {});
  const [menuListStatus, setMenuListStatus] = useState(initialMenuListToggleStatus || {});
  const waitConfirmBookingAmount = bookingData.filter(item => item.status === 'wc' && moment(item.date) > moment())
    .length;

  const getMenuItemActive = url => {
    return location.pathname === url ? ' menu-item-active menu-item-open ' : '';
  };

  const { branchList } = useSelector(state => state.booking2);

  const totalWaitingBooking2Count = getAllWaittingBookingCount(branchList);

  const { data: booking2ShopSetting } = useBooking2ShopSetting(shop);

  useEffect(() => {
    // console.log('user', user);
    if (!user) return;
    dispatch(fetchBookingList(isCustomer, ''));
  }, [isCustomer, user, dispatch]);

  useEffect(() => {
    if (user?.seqId == null) return;
    getBookingSetting(user.seqId).then(res => setBookingSetting(res.data.queryResult || null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    dispatch(fetchBookingBranchList());
  }, [user?.seqId, dispatch]);

  useEffect(() => {
    if (!user) return;
    setMenuListStatus(userMenu.reduce((acc, elem) => ({ ...acc, [elem.id]: false, 'menu.home': true }), {}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.mode]);

  const customTheme = useCustomTheme();
  const style = customTheme?.sidebar;

  const handleMouseEnter = (e, type, focus) => {
    const isFocus = focus && location.pathname === focus?.route;
    if (isFocus) {
      return;
    }
    if (type === 'menu') {
      e.currentTarget.style.background = style?.hoverBgColor;
    }
    if (type === 'submenu') {
      e.currentTarget.style.background = style?.subHoverBgColor;
    }
    if (type === 'font') {
      e.currentTarget.style.color = style?.hoverColor;
    }
    if (type === 'subfont') {
      e.currentTarget.style.color = style?.subHoverColor;
    }
  };

  const handleMouseLeave = (e, type, focus) => {
    const isFocus = focus && location.pathname === focus?.route;
    if (isFocus) {
      return;
    }
    if (type === 'menu') {
      e.currentTarget.style.background = style?.bgColor;
    }
    if (type === 'submenu') {
      e.currentTarget.style.background = style?.subBgColor;
    }
    if (type === 'font') {
      e.currentTarget.style.color = style?.color;
    }
    if (type === 'subfont') {
      e.currentTarget.style.color = style?.subColor;
    }
  };

  const menuBackground = (menu, isSubMenu) => {
    if (location.pathname === menu.route && !isSubMenu) return style.focusBgColor;
    if (location.pathname === menu.route && isSubMenu) return style.subFocusBgColor;
    if (isSubMenu) return style.subBgColor;
    return style.bgColor;
  };

  const ColoredSVG = useMemo(
    () =>
      styled(SVG)({
        width: 24,
        height: 24,
        color: style.icColor,
        '& path': {
          fill: 'currentColor !important',
          stroke: 'currentColor !important'
        },
        '.st1': {
          fill: 'none !important'
        }
      }),
    [style.icColor]
  );

  //CRITICAL PERFORMANCE WARNING: DO NOT ADD A VARIABLE THAT IS REDEFINED EVERY RENDER INTO THE CONTEXT
  //THIS IS WILL SINGLE HANDLEDLY CAUSE A MAJOR PERFORMANCE ISSUE
  const ctx = useMemo(() => {
    return {
      shop,
      user,
      style,
      waitConfirmBookingAmount,
      totalWaitingBooking2Count,
      waitConfirmOrderAmount,
      bookingSetting,
      booking2ShopSetting,
      isGlobalAdmin,
      isTerm
    };
  }, [
    shop,
    user,
    style,
    waitConfirmBookingAmount,
    totalWaitingBooking2Count,
    waitConfirmOrderAmount,
    bookingSetting,
    booking2ShopSetting,
    isGlobalAdmin,
    isTerm
  ]);

  const filteredUserMenu = useMemo(
    () =>
      userMenu.filter(mainItem => {
        // decided not to go with menu setting, new customer toggle feature will be implemented
        // if (!isEnabledBySetting(mainItem)) return false;

        const isCorrectPermission = mainItem.permission ? can(mainItem.permission) : true;
        const isMatchingAnyPermission = mainItem.permissions ? canAny(...mainItem.permissions) : true;
        const isCorrectCondition = mainItem.enabled ? mainItem.enabled(ctx, can) : true;
        if (!isCorrectPermission || !isCorrectCondition || !isMatchingAnyPermission) return false;

        const noSubMenuShown = mainItem.submenu
          ? // ? mainItem.submenu.every(sub => !isEnabledBySetting(sub) || !shouldRenderSubMenuItem(sub, ctx, can, canAny))
            mainItem.submenu.every(sub => !shouldRenderSubMenuItem(sub, ctx, can, canAny))
          : true;

        if (mainItem.submenu && noSubMenuShown) return false;

        return true;
      }),

    [userMenu, can, canAny, ctx, menuListStatus, location.pathname]
  );

  const mainMenuList = filteredUserMenu.map(mainItem => {
    const alertNumber = mainItem.getAlertNumber ? mainItem.getAlertNumber(ctx, can) : 0;

    const isOpen = !!menuListStatus[mainItem.id];

    let subMenuList = [];
    if (isOpen && mainItem.submenu) {
      subMenuList = (
        <SubMenuList
          // subMenu={mainItem.submenu.filter(isEnabledBySetting)}
          subMenu={mainItem.submenu}
          ctx={ctx}
          can={can}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          menuBackground={menuBackground}
          style={style}
        />
      );
    }

    return (
      <Fragment key={mainItem.id}>
        <li
          id="kt_aside_toggle"
          onClick={() => {
            if (mainItem.openNewTab) {
              window.open(mainItem.route || '/', '_blank');
              toggle.getOffcanvas().hide();
              return;
            }
            if (mainItem.submenu) {
              setMenuListStatus(prev => ({ ...prev, [mainItem.id]: !prev[mainItem.id] }));
              return;
            }
            history.push(mainItem.route || '/');
          }}
          className={`menu-item ${getMenuItemActive(mainItem.route)}`}
          aria-haspopup="true"
          role="menuitem"
        >
          <div
            className="menu-link"
            style={{
              padding: '9px 0px 9px 25px',
              background: menuBackground(mainItem, false)
            }}
            onMouseEnter={e => handleMouseEnter(e, 'menu', mainItem)}
            onMouseLeave={e => handleMouseLeave(e, 'menu', mainItem)}
          >
            <span
              className="menu-text font-weight-bold"
              onMouseEnter={e => handleMouseEnter(e, 'font', mainItem)}
              onMouseLeave={e => handleMouseLeave(e, 'font', mainItem)}
              style={{
                color: location.pathname === mainItem.route ? style.focusColor : style.color,
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}
            >
              {mainItem.icon ? <ColoredSVG src={toAbsoluteUrl(mainItem.icon)} /> : null}
              {formatMessage({ id: mainItem.id })}
              {mainItem.endAdornment ? mainItem.endAdornment(ctx) : null}
            </span>

            {!!alertNumber && <NotificationIcon>{alertNumber}</NotificationIcon>}
          </div>
        </li>
        {subMenuList}
      </Fragment>
    );
  });

  return <ul className={`menu-nav`}>{user && mainMenuList}</ul>;
}

const NotificationIcon = styled('div')(() => ({
  backgroundColor: 'red',
  padding: 4,
  width: 20,
  height: 20,
  borderRadius: 50,
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  color: 'white',
  margin: '4px 10px 0 0'
}));
